@if (userLoaded) {
    @if (isNonSystemUser) {
        <fdx-non-system-user-avatar [hasNotifications]="hasNotifications"/>
    } @else {
        <fdx-system-user-avatar
            [firstName]="firstName"
            [lastName]="lastName"
            [hasNotifications]="hasNotifications"/>
    }
}
